import normalMode from "../../normalMode";
import {EventParamsTypeConstant} from "../const/EventParamsTypeConstant";
import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

/**
 * 特殊 事件展示
 */
@ccclass
export default class NoticeEventShow extends cc.Component {

    @property(cc.Label)
    lbDesc : cc.Label = null;
    @property(cc.Node)
    hourNode : cc.Node = null;
    @property(cc.Node)
    strongerNode : cc.Node = null;
    @property(cc.Node)
    moodNode : cc.Node = null;
    @property(cc.Node)
    healthNode : cc.Node = null;
    @property(cc.Node)
    moneyNode : cc.Node = null;

    private mParentScript : normalMode ;

    onLoad () {
        O1HD.on("NoticeEventShow.hidden" , this.hidden , this );
    }

    start () {

    }

    bindData( desc : string , effectParams : { key : number , value : number }[], gameLayer : normalMode  ){
        this.lbDesc.string = `${desc}`;
        // for ( let effectParam of effectParams ) {
        //     switch ( effectParam.key ) {
        //         case EventParamsTypeConstant.HOUR:
        //             // this.hourNode.active = true;
        //             // let hourTemp : string ;
        //             // if ( effectParam.value > 0 ) {
        //             //     hourTemp = `+${effectParam.value}小时`;
        //             //     this.hourNode.getChildByName("lbHour").color = cc.color( 229 , 109 , 109 );
        //             // }else{
        //             //     hourTemp = `-${effectParam.value}小时`;
        //             //     this.hourNode.getChildByName("lbHour").color = cc.color( 113 , 210 , 110 );
        //             // }
        //             // this.hourNode.getChildByName("lbHour").getComponent(cc.Label).string = hourTemp;
        //             break;
        //         case EventParamsTypeConstant.STRONGER:
        //             if ( effectParam.value != 0 ){
        //                 this.strongerNode.active = true;
        //                 let strongerTemp : string;
        //                 if ( effectParam.value > 0 ) {
        //                     strongerTemp = `+${effectParam.value}`;
        //                     this.strongerNode.getChildByName("lbStronger").color = cc.color( 113 , 210 , 110 );
        //                 }else{
        //                     strongerTemp = `${effectParam.value}`;
        //                     this.strongerNode.getChildByName("lbStronger").color = cc.color( 229 , 109 , 109 );
        //                 }
        //                 this.strongerNode.getChildByName("lbStronger").getComponent(cc.Label).string = strongerTemp;
        //                 break;
        //             }
        //         case EventParamsTypeConstant.MOOD:
        //             if ( effectParam.value != 0 ){
        //                 this.moodNode.active = true;
        //                 let moodTemp : string;
        //                 if ( effectParam.value > 0 ) {
        //                     moodTemp = `+${effectParam.value}`;
        //                     this.moodNode.getChildByName("lbMood").color = cc.color( 113 , 210 , 110 );
        //                 }else{
        //                     moodTemp = `${effectParam.value}`;
        //                     this.moodNode.getChildByName("lbMood").color = cc.color( 229 , 109 , 109 );
        //                 }
        //                 this.moodNode.getChildByName("lbMood").getComponent(cc.Label).string = moodTemp;
        //                 break;
        //             }
        //         case EventParamsTypeConstant.HEALTH:
        //             if ( effectParam.value != 0 ){
        //                 this.healthNode.active = true;
        //                 let healthTemp : string;
        //                 if ( effectParam.value > 0 ) {
        //                     healthTemp = `+${effectParam.value}`;
        //                     this.healthNode.getChildByName("lbHealth").color = cc.color( 113 , 210 , 110 );
        //                 }else{
        //                     healthTemp = `${effectParam.value}`;
        //                     this.healthNode.getChildByName("lbHealth").color = cc.color( 229 , 109 , 109 );
        //                 }
        //                 this.healthNode.getChildByName("lbHealth").getComponent(cc.Label).string = healthTemp;
        //             }
        //             break;
        //         case EventParamsTypeConstant.MONEY:
        //             this.moneyNode.active = true;
        //             let moneyTemp : string;
        //             if ( effectParam.value > 0 ) {
        //                 moneyTemp = `+${effectParam.value}`;
        //                 this.moneyNode.getChildByName("lbMoney").color = cc.color( 113 , 210 , 110 );
        //             }else{
        //                 moneyTemp = `${effectParam.value}`;
        //                 this.moneyNode.getChildByName("lbMoney").color = cc.color( 229 , 109 , 109 );
        //             }
        //             this.moneyNode.getChildByName("lbMoney").getComponent(cc.Label).string = moneyTemp;
        //             break;
        //     }
        // }
        this.mParentScript = gameLayer;
        // this.mParentScript.gameManager.effectParamsDealWith( effectParams );
        // this.scheduleOnce(()=>{
        //     this.onClose();
        // },5 );
    }

    onBtnMakeSure(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.onClose();
    }

    /**
     * 知道了
     */
    onClose(){
         this.mParentScript.specialEventShow();
         this.node.removeFromParent();
         this.node.destroy();
    }


    /**
     * 消息
     */
    hidden(){
        this.node.removeFromParent();
        this.node.destroy();
    }
}
